import { render, staticRenderFns } from "./TextDisplay.vue?vue&type=template&id=4f54990a"
import script from "./TextDisplay.vue?vue&type=script&lang=js"
export * from "./TextDisplay.vue?vue&type=script&lang=js"
import style0 from "./TextDisplay.vue?vue&type=style&index=0&id=4f54990a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports